import NextLink from 'next/link';

import {AnimatedText, Button} from '#component/base';
import {sprinkles} from '#style/sprinkles';

export const PendingSurveyKitHeader = () => (
  <div
    className={sprinkles({
      colSpan: [4, 6, 10],
      colStart: [1, 2],
      dir: ['col', 'row'],
      flex: 'flex',
      gap: 32,
    })}>
    <div className={sprinkles({dir: 'col', flex: 'flex', gap: 32})}>
      <AnimatedText color="inherit" variant="heading1">
        TallyAge™ coming soon!
      </AnimatedText>
    </div>
    <div className={sprinkles({dir: 'col', flex: 'flex', gap: 64})}>
      <AnimatedText color="inherit">
        Your TallyAge™ is being processed. When completed, we will share your TallyAge™ results
        here.
      </AnimatedText>
      <div className={sprinkles({dir: ['col', 'row'], flex: 'flex', gap: 16})}>
        <NextLink href="/survey" passHref>
          <Button
            as="a"
            className={sprinkles({w: ['full', 'maxContent']})}
            icon="ArrowRight"
            variant="primary-dark">
            Take a Lifestyle Survey
          </Button>
        </NextLink>
      </div>
    </div>
  </div>
);
